'use strict';
(function () {
  if (!customElements.get('featured-collection')) {
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.slider = this.querySelector('.product-grid');
        this.nextBtns = this.querySelectorAll('.swiper-button-next');
        this.prevBtns = this.querySelectorAll('.swiper-button-prev');
        this.slidesPerView = this.dataset.slidesPerView;
        this.allSlides = +this.dataset.allSlides;
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';

        const { spaceBetween, spaceBetweenTb, spaceBetweenPc } = this.dataset;
        const slidesPerView = this.allSlides < this.slidesPerView ? this.allSlides : this.slidesPerView;
        const slidesPerViewTb = this.allSlides < 2.5 ? this.allSlides : 2.5;

        this.swiperParams = {
          slidesPerView: 'auto',
          spaceBetween: 10,
          slideToClickedSlide: false,
          scrollbar: true,
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
          breakpoints: {
            750: {
              slidesPerView: slidesPerViewTb,
              spaceBetween: spaceBetweenTb,
            },
            1024: {
              slidesPerView,
              spaceBetween: spaceBetweenPc,
            },
          },
        };
      }

      connectedCallback() {
        if (this.slider) {
          this.initSwiper();
          this.handleResize = debounce(this.handleResize.bind(this), 200);
          window.addEventListener('resize', this.handleResize);
          this.setupExternalNavigation();
        }
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        this.destroySwiper();
      }

      canInitSwiper = () => {
        if (!this.slider) return false;
        if (window.innerWidth <= 749) return true;
        return false;
      };

      handleResize = () => {
        if (this.canInitSwiper()) {
          this.initSwiper();
          return;
        }
        this.destroySwiper();
      };

      setupExternalNavigation = () => {
        this.nextBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            if (this.swiper) this.swiper.slideNext();
          });
        });
        this.prevBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            if (this.swiper) this.swiper.slidePrev();
          });
        });
      };
    }

    FeaturedCollection.prototype.initSwiper = function () {
      if (!this.canInitSwiper() || this.swiper) return;
      this.prepareMobileSliderMarkup();
      this.swiper = new Swiper(this.slider, this.swiperParams);

      this.updateNavigationButtons();

      this.swiper.on('init', this.updateNavigationButtons.bind(this));
      this.swiper.on('slideChange', this.updateNavigationButtons.bind(this));
      this.swiper.init();
    };

    FeaturedCollection.prototype.destroySwiper = function () {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this.restoreGridMarkup();
    };

    FeaturedCollection.prototype.prepareMobileSliderMarkup = function () {
      if (!this.slider || this.slider.querySelector(':scope > .swiper-wrapper')) return;
      this.slider.classList.add('swiper');

      const wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';

      const gridItems = Array.from(this.slider.querySelectorAll(':scope > .grid__item'));
      gridItems.forEach((item) => {
        item.classList.add('swiper-slide');
        wrapper.appendChild(item);
      });

      this.slider.prepend(wrapper);

      if (!this.slider.querySelector(':scope > .swiper-scrollbar')) {
        const scrollbar = document.createElement('div');
        scrollbar.className = 'swiper-scrollbar';
        this.slider.appendChild(scrollbar);
      }
    };

    FeaturedCollection.prototype.restoreGridMarkup = function () {
      if (!this.slider) return;

      const wrapper = this.slider.querySelector(':scope > .swiper-wrapper');
      if (!wrapper) {
        this.slider.classList.remove('swiper');
        return;
      }

      const gridItems = Array.from(wrapper.children);
      gridItems.forEach((item) => {
        item.classList.remove('swiper-slide');
        this.slider.insertBefore(item, wrapper);
      });

      wrapper.remove();

      const scrollbar = this.slider.querySelector(':scope > .swiper-scrollbar');
      if (scrollbar) scrollbar.remove();
      this.slider.classList.remove('swiper');
    };

    FeaturedCollection.prototype.toggleButtonState = function (button, shouldDisable) {
      if (shouldDisable) {
        button.classList.add('disabled');
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.classList.remove('disabled');
        button.removeAttribute('aria-disabled');
      }
    };

    FeaturedCollection.prototype.updateNavigationButtons = function () {
      if (!this.swiper) return;
      const { isBeginning, isEnd } = this.swiper;
      this.prevBtns.forEach((btn) => {
        this.toggleButtonState(btn, isBeginning);
      });

      this.nextBtns.forEach((btn) => {
        this.toggleButtonState(btn, isEnd);
      });
    };

    customElements.define('featured-collection', FeaturedCollection);
  }
})();
